import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_ACCESS} from '../../constants';

export default {
  id: 'PARAM_COMPT',
  title: 'Come posso modificare i miei informazioni personali?',
  description: '',
  categories: [CONTENT_CATEGORY_ACCESS],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Per modificare i tuoi informazioni personali, clicca sull\' icona in basso a sinistra'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_PARAM_COMPT/IT_PARAM_COMPT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Poi clicca su «Informazioni personali»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_PARAM_COMPT/IT_PARAM_COMPT_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'È quindi possibile aggiornare le informazioni personali e quindi convalidare'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_PARAM_COMPT/IT_PARAM_COMPT_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Per motivi di sicurezza, si noti che:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- La persona che svolge il ruolo di Account Manager non può modificare tutte le sue informazioni personali'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- La persona in possesso della firma elettronica dei documenti non può modificare tutte le sue informazioni personali.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Per farlo deve rivolgersi al Servizio Clienti.'
  }]
};
